const dateOptions = {
  day: 'numeric',
  month: 'short',
} as const

export default function formatDateRange(
  startDate: string,
  endDate: string,
  options: Intl.DateTimeFormatOptions = dateOptions
) {
  const formattedStart = new Date(startDate).toLocaleDateString('en', options)
  const formattedEnd = new Date(endDate).toLocaleDateString('en', options)

  return `${formattedStart} - ${formattedEnd}`
}
